<nz-form-control>
  <nz-input-group
    nzSearch
    [nzAddOnAfter]="recordProperty?.ReadOnly ? View : suffixIconButton"
  >
    <input
      nz-input
      [(ngModel)]="recordProperty.ValueAsObject"
      (input)="onType($event)"
      [ngModelOptions]="{ updateOn: 'blur' }"
      (ngModelChange)="modelChanged($event)"
      [nzAutocomplete]="auto"
      [readonly]="recordProperty.ReadOnly"
      (keydown.Tab)="onKey($event)"
      [class]="parentClass"
    />
  </nz-input-group>
  <ng-template #suffixIconButton>
    <button
      nz-button
      nzType="default"
      nzSearch
      (click)="openView()"
      *ngIf="recordProperty.ReadOnly"
    >
      <i class="fal fa-eye"></i>
    </button>
    <nz-button-group *ngIf="!recordProperty.ReadOnly">
      <button
        nz-button
        nz-dropdown
        [nzDropdownMenu]="options"
        nzTrigger="click"
        (nzVisibleChange)="triggerMenu($event)"
      >
        <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
      </button>
      <nz-dropdown-menu #options="nzDropdownMenu">
        <ul nz-menu *ngIf="loadingDropDownMenu">
          <li nz-menu-item>
            <nz-spin nzSimple></nz-spin> {{ "Loading" | locale }}
          </li>
        </ul>
        <ul nz-menu *ngIf="!loadingDropDownMenu && moduleInformation != null">
          <li
            nz-menu-item
            (click)="openSearchDrawer()"
            *ngIf="moduleInformation.AuthorisedForList"
            [class]="'search-button-field-' + field.Id"
          >
            <i class="fal fa-search"></i> {{ "Search" | locale }}
          </li>
          <li
            nz-menu-item
            (click)="openCreationInside()"
            *ngIf="moduleInformation.AuthorisedForCreate"
            [class]="'new-button-field-' + field.Id"
          >
            <i class="fal fa-asterisk"></i> {{ "Create New" | locale }}
          </li>
          <li
            nz-menu-item
            (click)="openView()"
            *ngIf="moduleInformation.AuthorisedForView"
          >
            <i class="fal fa-eye"></i> {{ "View" | locale }}
          </li>
          <li
            nz-menu-item
            [nzDisabled]="true"
            *ngIf="
              !moduleInformation.AuthorisedForList &&
              !moduleInformation.AuthorisedForCreate &&
              !moduleInformation.AuthorisedForView
            "
            [class]="'view-button-field-' + field.Id"
          >
            <i class="fal fa-lock"></i>
            {{
              "There is no selected module, or you are not authorized to use the selected module."
                | locale
            }}
          </li>
        </ul>
      </nz-dropdown-menu>
    </nz-button-group>
  </ng-template>
  <ng-template #View>
    <nz-button-group>
      <button nz-button nzType="default" nzSearch (click)="openView()">
        <i class="fal fa-eye"></i>
      </button>
    </nz-button-group>
  </ng-template>
</nz-form-control>
<nz-autocomplete #auto [nzOverlayClassName]="'linked-field-overlay'" (selectionChange)="selectionChangedFromAutoComplete($event)">
  <nz-auto-option *ngFor="let option of options" [nzValue]="option.value">{{
    option.label
  }}</nz-auto-option>
</nz-autocomplete>

<!-- <nz-drawer [nzVisible]="creationInsideShowHide" (nzOnClose)="creationInsideShowHide = false;"
  nzWrapClassName="drawer-size-3x" [nzTitle]="'Create New' | locale">
  <app-record-page *ngIf="creationInsideShowHide" [moduleId]="creationInsideModule" [showCommunication]="false"
    [inDrawer]="true" [actionType]="'Add'" (objectSubmitted)="objectSubmitted($event);">
  </app-record-page>
</nz-drawer> -->
